// src/features/system/iam/api/commsApi.ts
//
// Frontend API layer for admin comms actions.
// Calls the BFF /orchestrator/comms/* compatibility endpoints, backed by Rust comms.

import { bff } from '@/lib/http/bff';

/* ─── Types ───────────────────────────────────────────────── */

/** Response from admin comms send endpoints. */
export interface CommsSendResponse {
  sent: boolean;
  channel: string;
  to: string;
  template: string;
  id_user: number;
  accepted?: boolean;
  pending_delivery?: boolean;
  detail?: string;
}

/** Payload for custom notification email. */
export interface NotifyPayload {
  title: string;
  message: string;
}

/** Comms health per-channel map. */
export interface CommsHealthResponse {
  channels: Record<string, string>;
}

/* ─── API Calls ───────────────────────────────────────────── */

/** Send welcome email to a user by user ID. */
export async function sendAdminWelcome(idUser: number): Promise<CommsSendResponse> {
  return bff.post<CommsSendResponse>(
    `/orchestrator/comms/admin/users/${idUser}/welcome`,
  );
}

/** Send password-reset email to a user by user ID. */
export async function sendAdminReset(idUser: number): Promise<CommsSendResponse> {
  return bff.post<CommsSendResponse>(
    `/orchestrator/comms/admin/users/${idUser}/reset`,
  );
}

/** Send custom notification email to a user by user ID. */
export async function sendAdminNotify(
  idUser: number,
  payload: NotifyPayload,
): Promise<CommsSendResponse> {
  return bff.post<CommsSendResponse>(
    `/orchestrator/comms/admin/users/${idUser}/notify`,
    payload,
  );
}

/** Check health of all comms channels. */
export async function fetchCommsHealth(): Promise<CommsHealthResponse> {
  return bff.get<CommsHealthResponse>('/orchestrator/comms/health');
}
